const state = {
	scParam: {
		courseTypeId: '',
		courseId: ''
	    , kpList: []
	    , kpIdList: []
	    , resType: ''
	    , origin:''
	    , orderBy: 1
	    , sort: 0
	    , name: ''
	    , pageNum: 1
	}
}
const mutations = {
    SET_SC_PARAM: (state, param) => {
      // console.log(param)
        state.scParam.courseTypeId = param.courseTypeId;
        state.scParam.courseId = param.courseId;
        state.scParam.kpList = param.kpList;
        state.scParam.kpIdList = param.kpIdList;
        state.scParam.resType = param.resType;
        state.scParam.origin = param.origin;
        state.scParam.orderBy = param.orderBy;
        state.scParam.sort = param.sort;
        state.scParam.name = param.name;
        state.scParam.pageNum = param.pageNum;
    },
}

export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/b000201.js